// src/compass/component/types.ts
var CompassComponentAriResourceOwner = "compass", CompassComponentAriResourceType = "component";

export {
  CompassComponentAriResourceOwner,
  CompassComponentAriResourceType
};
